var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Observable, of as observableOf } from 'rxjs';
import { Select } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
var FoldersTreeService = /** @class */ (function () {
    function FoldersTreeService() {
        this.createTreeFlattener();
        this.createTreeControl();
        this.createTreeDataSource();
        this.bindToStore();
    }
    FoldersTreeService.prototype.createTreeFlattener = function () {
        this.flattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    };
    FoldersTreeService.prototype.createTreeControl = function () {
        this.control = new FlatTreeControl(this.getLevel, this.isExpandable);
    };
    FoldersTreeService.prototype.createTreeDataSource = function () {
        this.dataSource = new MatTreeFlatDataSource(this.control, this.flattener);
    };
    FoldersTreeService.prototype.bindToStore = function () {
        var _this = this;
        this.userFolders$
            .pipe(filter(function (x) { return !!x; }))
            .subscribe(function (folders) {
            _this.dataSource.data = folders;
        });
    };
    FoldersTreeService.prototype.transformer = function (node, level) {
        var flatNode = Object.assign({}, node);
        flatNode.level = level;
        flatNode.expandable = !!node.children;
        return flatNode;
    };
    FoldersTreeService.prototype.getLevel = function (node) {
        return node.level;
    };
    FoldersTreeService.prototype.isExpandable = function (node) {
        return node.expandable;
    };
    FoldersTreeService.prototype.getChildren = function (node) {
        return observableOf(node.children);
    };
    FoldersTreeService.ngInjectableDef = i0.defineInjectable({ factory: function FoldersTreeService_Factory() { return new FoldersTreeService(); }, token: FoldersTreeService, providedIn: "root" });
    __decorate([
        Select(DriveState.userFolders),
        __metadata("design:type", Observable)
    ], FoldersTreeService.prototype, "userFolders$", void 0);
    return FoldersTreeService;
}());
export { FoldersTreeService };
